import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import styled from "styled-components";
import React, { useState } from "react";
import Flatpickr from "react-flatpickr";
import dateFormat from "dateformat";
import classnames from "classnames";
import CustomSelect from "../../../../components/Common/CustomSelect";
import ConditionItems from "./ConditionItems";
import CustomMiniLoader from "../../../../components/CustomMiniLoader/CustomMiniLoader";

const CampaignCashbackBlock = props => {
  const [rangeDate, setRangeDate] = React.useState([
    props.cashback.date_from ? new Date(props.cashback.date_from) : new Date(),
    props.cashback.date_to ? new Date(props.cashback.date_to) : new Date(),
  ]);
  const [selectedSource, setSelectedSource] = React.useState();
  const [selectedServiceProvider, setServiceProvider] = React.useState();
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);

  const createIndex = () =>
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  const [regions, setRegions] = useState(
    props.cashback?.regions
      ? props.cashback?.regions.map(i => {
        return {
          idx: createIndex(),
          conditions: i.conditions.map(c => {
            return {
              min_value: c.min_value,
              max_value: c.max_value,
              coef: c.coef,
              idx: createIndex(),
            };
          }),
          countries: i.countries,
        };
      })
      : [
        {
          idx: createIndex(),
          countries: [],
          conditions: [
            {
              min_value: "0",
              max_value: "0",
              coef: "0",
              idx: createIndex(),
            },
          ],
        },
      ]
  );

  React.useEffect(() => {
    if (props.cashback?.media_source_name) {
      props.sources.map(item => {
        if (item.label === props.cashback?.media_source_name) {
          setSelectedSource(item);
        }
      });
    }
    if (props.cashback?.service_provider_id) {
      props.service_providers.map(item => {
        if (item.value === props.cashback?.service_provider_id) {
          setServiceProvider({
            label: item.label,
            value: item.value,
          });
        }
      });
    } else {
      setServiceProvider({
        label: 'None',
        value: null,
      });
    }
  }, [props.service_providers, props.sources]);

  const handleValidOrderSubmit = (e, params) => {
    setIsFormSubmit(true);
    const copyRegions = Object.assign([], regions);
    let errorMinMax = false;
    const items = [];
    copyRegions.map(i => {
      items.push({
        conditions: i.conditions.map(c => {
          if (c.min_value > c.max_value || c.max_value < c.min_value) {
            errorMinMax = true;
          }

          return {
            min_value: c.min_value || 0,
            max_value: c.max_value || 0,
            coef: c.coef || 0,
          };
        }),
        countries: i.countries,
      });
    });

    let cashback = {
      name: params.name,
      media_source_id: params.media_source_id.value,
      service_provider_id: params.service_provider_id.value,
      date_from: dateFormat(rangeDate[0], "yyyy-mm-dd"),
      date_to: dateFormat(rangeDate[1], "yyyy-mm-dd"),
      regions: items,
    };

    props.saveChangeAction(cashback);
  };

  const conditionsSettings = (type, index, custom_id) => {
    const copyRegions = Object.assign([], regions);
    switch (type) {
      case "create":
        copyRegions[index].conditions.push({
          min_value: 0,
          max_value: 0,
          coef: 0,
          idx: createIndex(),
        });
        setRegions(copyRegions);
        break;
      case "delete":
        let i = copyRegions[index].conditions.findIndex(
          n => n.idx === custom_id
        );
        i !== -1 && copyRegions[index].conditions.splice(i, 1);
        return setRegions(copyRegions);
    }
  };

  const regionsSettings = (type, idx, data) => {
    switch (type) {
      case "create":
        return setRegions([
          ...regions,
          {
            idx: createIndex(),
            countries: [],
            conditions: [
              {
                min_value: 0,
                max_value: 0,
                coef: 0,
                idx: createIndex(),
              },
            ],
          },
        ]);
      case "change":
        return setRegions(prev =>
          prev.map(i =>
            i.idx !== idx
              ? i
              : {
                ...i,
                countries:
                  data !== ""
                    ? data.map(c => {
                      return c.value;
                    })
                    : [],
              }
          )
        );
      case "delete":
        return setRegions(
          regions.filter(i => {
            return i.idx !== idx;
          })
        );
    }
  };

  const handleChangeCondition = (region_idx, index, change, value) => {
    const copyRegions = Object.assign([], regions);
    copyRegions[region_idx].conditions[index][change] = value;

    if (change === "min_value" || change === "max_value") {
      const currentMinValue = parseFloat(
        copyRegions[region_idx].conditions[index].min_value
      );
      const currentMaxValue = parseFloat(
        copyRegions[region_idx].conditions[index].max_value
      );

      if (!isNaN(currentMinValue) && !isNaN(currentMaxValue)) {
        if (change === "min_value" && currentMinValue > currentMaxValue) {
          copyRegions[region_idx].conditions[index].max_value = value;
        } else if (
          change === "max_value" &&
          currentMaxValue < currentMinValue
        ) {
          copyRegions[region_idx].conditions[index].min_value = value;
        }
      }
    }

    setRegions(copyRegions);
  };

  const getLabelCountries = (data = []) => {
    if (data.length === 0) return "All countries";
    if (!props.countries || props.countries?.length === 0) return "Waiting...";

    const rez = data.map(val => {
      if (typeof val === "object") {
        return props.countries.find(i => i.value === val.value)?.label || "";
      } else {
        return props.countries.find(i => i.value === val)?.label || "";
      }
    });
    return rez.join(", ");
  };

  const getDefaultValue = data => {
    if (data.length === 0) return "";
    if (!props.countries || props.countries?.length === 0) return "";
    const rez = data.map(val => {
      if (typeof val === "object") {
        return props.countries.find(i => i.value === val.value) || "";
      } else {
        return props.countries.find(i => i.value === val) || "";
      }
    });
    return rez;
  };

  return (
    <Row className="d-flex justify-content-center">
      <Col lg={9}>
        <AvForm onValidSubmit={handleValidOrderSubmit}>
          <Card className="mb-0">
            <CardBody>
              <Row>
                <Col lg={6}>
                  <div className="mt-2">
                    <Label>Name</Label>
                    <AvField
                      name="name"
                      type="text"
                      errorMessage="This value is required."
                      value={props.cashback?.name || ""}
                      placeholder="Name..."
                      validate={{
                        required: { value: true },
                        maxLength: {
                          value: 150,
                          errorMessage: "Max 255 characters.",
                        },
                        minLength: {
                          value: 1,
                          errorMessage: "Min 1 character",
                        },
                      }}
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mt-2">
                    <Label>Media source</Label>
                    <CustomSelect
                      name={`media_source_id`}
                      placeholder="Select media source..."
                      options={props.sources || []}
                      defaultValue={selectedSource}
                      isLoading={props.sources_loading}
                      classNamePrefix="select2-selection"
                      errorMessage="Media source field is required"
                      onChange={e => setSelectedSource(e)}
                      isFormSubmit={isFormSubmit}
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mt-2">
                    <Label>Service provider</Label>
                    <CustomSelect
                      name={`service_provider_id`}
                      placeholder="Select service provider..."
                      options={props.service_providers || []}
                      defaultValue={selectedServiceProvider}
                      isLoading={props.service_providers_loading}
                      classNamePrefix="select2-selection"
                      onChange={e => setServiceProvider(e)}
                      isFormSubmit={isFormSubmit}
                      errorMessage="Service provider field is required"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mt-2">
                    <Label>Date range</Label>
                    <Flatpickr
                      name="date"
                      className="form-control d-block"
                      value={rangeDate}
                      onChange={date => setRangeDate(date)}
                      style={{ backgroundColor: "white" }}
                      options={{
                        mode: "range",
                        dateFormat: "Y-m-d",
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col lg="6">
                  <h4 style={{ marginTop: "40px" }}>Regions</h4>
                </Col>
                <Col lg={6}>
                  {!props.readOnly && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-rounded me-2"
                      style={{
                        position: "absolute",
                        bottom: 0,
                        right: 4,
                      }}
                      onClick={() => regionsSettings("create")}
                    >
                      <i className="mdi mdi-plus me-1" /> Add region
                    </Button>
                  )}
                </Col>
              </Row>
              {regions.map((i, idx) => (
                <div
                  className=""
                  style={{ borderLeft: "5px solid #556EE6", margin: "10px 0" }}
                  key={idx}
                >
                  <div className="accordion" id="accordion">
                    <AccordionItem className={classnames("accordion-item")}>
                      <h2 className="accordion-header" id="headingOne">
                        <span
                          className={classnames(
                            "accordion-button fw-medium d-flex justify-content-between"
                          )}
                          style={{ cursor: "initial", borderTopLeftRadius: 0 }}
                        >
                          <div className="w-100 m-0 m-auto d-flex justify-content-between align-items-center">
                            <span>{getLabelCountries(i.countries)}</span>
                            <Button
                              onClick={() => regionsSettings("delete", i.idx)}
                              color="danger"
                              className="btn-block inner me-3 btn-sm"
                              style={{
                                visibility:
                                  regions?.length === 1 ? "hidden" : "visible",
                              }}
                            >
                              <i className="mdi mdi-trash-can font-size-16" />
                            </Button>
                          </div>
                        </span>
                      </h2>
                    </AccordionItem>
                  </div>
                  <div className="m-auto mt-3 mb-3 me-3 ms-3">
                    <Row className="justify-content-center">
                      <Col md={8}>
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="">Countries:</Label>
                              <CustomSelect
                                name={`countries|${i.idx}`}
                                options={props.countries}
                                defaultValue={getDefaultValue(
                                  regions[idx].countries
                                )}
                                placeholder="Select countries..."
                                classNamePrefix="select2-selection"
                                errorMessage="Countries field is required"
                                onChange={e =>
                                  regionsSettings("change", i.idx, e)
                                }
                                changeOptionsRender
                                isMulti
                              />
                            </FormGroup>
                            <Label htmlFor="">Cashbacks conditions:</Label>
                            {i.conditions.map((condition, condition_idx) => (
                              <ConditionItems
                                key={condition_idx}
                                index={condition_idx}
                                region_idx={idx}
                                handleChangeCondition={handleChangeCondition}
                                data={condition}
                                num={i.conditions.length}
                                keys={condition.idx}
                                onDelete={() =>
                                  conditionsSettings(
                                    "delete",
                                    idx,
                                    condition.idx
                                  )
                                }
                              />
                            ))}
                            <Row>
                              <div className="text-end my-0 mt-2">
                                <Button
                                  color="primary"
                                  type="button"
                                  onClick={() =>
                                    conditionsSettings("create", idx, i.idx)
                                  }
                                >
                                  <i className="mdi mdi-plus" /> Add condition
                                </Button>
                              </div>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              ))}
            </CardBody>
          </Card>
          <Row className="mt-3 mb-3">
            <Col>
              <ButtonContainer>
                {props.loading ? (
                  <div>
                    <CustomMiniLoader
                      className="fade-in-custom-animate"
                      style={{ padding: "10px", minWidth: "143px" }}
                      status
                      text="Please wait"
                    />
                  </div>
                ) : (
                  <div>
                    <button
                      type="button"
                      onClick={() => props.history.push(`/cashbacks`)}
                      className="btn btn-outline-primary save-user fade-in-custom-animate"
                    >
                      Back to cashbacks
                    </button>
                    {!props.readOnly && (
                      <button
                        type="submit"
                        className="btn btn-success save-user fade-in-custom-animate ms-3"
                      >
                        Save changes
                      </button>
                    )}
                  </div>
                )}
              </ButtonContainer>
            </Col>
          </Row>
        </AvForm>
      </Col>
    </Row>
  );
};

const AccordionItem = styled.div`
  background-color: transparent;
  border: 0px solid rgba(0, 0, 0, 0) !important;
  margin: 0;
  cursor: initial;

  .accordion-button::after {
    background: none !important;
    display: none !important;
  }

  &:first-child {
    margin-top: 0;
  }

  .accordion-button {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .btn-danger {
    margin: 0 !important;
  }

  &.accordion-item__is-close {
    background-color: red !important;
  }
`;

const ButtonContainer = styled.div`
  text-align: right !important;
`;

CampaignCashbackBlock.propTypes = {
  saveChangeAction: PropTypes.func.isRequired,
  cashback: PropTypes.any,
  history: PropTypes.object.isRequired,
  countries: PropTypes.any,
  readOnly: PropTypes.bool,
  loading: PropTypes.bool,
  sources: PropTypes.any,
  sources_loading: PropTypes.bool,
  service_providers: PropTypes.any,
  service_providers_loading: PropTypes.bool,
};

export default CampaignCashbackBlock;
